const FETCH_TIMEOUT_MS = 15000;

// const BACKEND_URL = "http://localhost:8000";
// const TENANT_ID = "cfcb6d49-bc76-4a81-92a1-9ad75d07516c";
// const CLIENT_ID = "27bd57fc-f06b-4d5a-b939-3d0d1b8bd5ef";
// const RESOURCE = "api://8955ca60-e227-4a43-ac67-78df4e870e86";
const BACKEND_URL = "https://dev.legalspot.pl/api"; 
const TENANT_ID = "cfcb6d49-bc76-4a81-92a1-9ad75d07516c"; 
const CLIENT_ID = "27bd57fc-f06b-4d5a-b939-3d0d1b8bd5ef"; 
const RESOURCE = "api://8955ca60-e227-4a43-ac67-78df4e870e86"; // client ID backendu
// const BACKEND_URL = "https://profbud.legalspot.pl/api";
// const TENANT_ID = "e3658ff1-b026-400b-a5b4-2090eae8f85a";
// const CLIENT_ID = "6e14f618-bd78-48dd-8edf-dc5c0d3d8a56";
// const RESOURCE = "api://ac556edd-c442-472b-8220-45ca36978415";
const RESOURCE_SCOPE = `${RESOURCE}/access`;

const MSAL_CONFIG = {
  auth: {
    clientId: CLIENT_ID,
    authority: "https://login.microsoftonline.com/" + TENANT_ID,
    redirectUri: window.location.origin + window.location.pathname,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

let msalApp = null;
let backendJwt = null;

let loginPromise = null;
let didPostLoginRefresh = false;

let usersController = null;
let usersDebounceTimer = null;
let lastUsersQuery = null;

function decodeJwt(token) {
  try {
    const payload = token.split(".")[1];
    const json = atob(payload);
    return JSON.parse(json);
  } catch {
    return {};
  }
}

function qp(name) {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch {
    return null;
  }
}

function escapeHtml(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function normalizeString(v) {
  return typeof v === "string" ? v : v == null ? "" : String(v);
}

function getSubjectAsync(item) {
  if (typeof item?.subject === "string") return Promise.resolve(item.subject);
  if (item?.subject && typeof item.subject.getAsync === "function") {
    return new Promise((resolve) => {
      item.subject.getAsync((res) => {
        if (res.status === Office.AsyncResultStatus.Succeeded) resolve(res.value || "");
        else resolve("");
      });
    });
  }
  return Promise.resolve("");
}

async function ensureMsalLoaded() {
  if (window.msal?.PublicClientApplication) return;

  const sources = [
    "https://alcdn.msauth.net/browser/2.38.4/js/msal-browser.min.js",
    "https://cdn.jsdelivr.net/npm/@azure/msal-browser@2.38.4/lib/msal-browser.min.js",
    "https://unpkg.com/@azure/msal-browser@2.38.4/lib/msal-browser.min.js",
    "https://legalplugin.legalspot.pl/lib/msal-browser.min.js",
  ];

  let lastErr;
  for (const src of sources) {
    try {
      await loadScriptWithTimeout(src, 12000);
      if (window.msal?.PublicClientApplication) return;
      lastErr = new Error("MSAL loaded but PublicClientApplication missing");
    } catch (e) {
      lastErr = e;
    }
  }
  throw lastErr || new Error("MSAL script failed to load from all sources");
}

function loadScriptWithTimeout(src, timeoutMs) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    const to = setTimeout(() => {
      s.onerror = s.onload = null;
      reject(new Error(`Timeout loading: ${src}`));
    }, timeoutMs);
    s.onload = () => {
      clearTimeout(to);
      resolve();
    };
    s.onerror = () => {
      clearTimeout(to);
      reject(new Error(`Failed to load: ${src}`));
    };
    document.head.appendChild(s);
  });
}

async function getAccessTokenWithFallback() {
  try {
    const token = await Office.auth.getAccessToken({
      allowSignInPrompt: true,
      forMSGraph: false,
    });
    if (token) return token;
  } catch (e) {
    console.warn("Office SSO failed:", e);
  }

  await ensureMsalLoaded();
  const msalGlobal = window.msal;

  if (!msalApp) {
    msalApp = new msalGlobal.PublicClientApplication(MSAL_CONFIG);
    if (msalApp.initialize) await msalApp.initialize();
  }

  let account =
    msalApp.getActiveAccount?.() ||
    (msalApp.getAllAccounts && msalApp.getAllAccounts()[0]) ||
    null;

  if (!account) {
    const loginRes = await msalApp.loginPopup({
      scopes: [RESOURCE_SCOPE],
    });
    account = loginRes.account;
    msalApp.setActiveAccount?.(account);
  }

  try {
    const res = await msalApp.acquireTokenSilent({
      account,
      scopes: [RESOURCE_SCOPE],
    });
    return res.accessToken;
  } catch {
    const res = await msalApp.acquireTokenPopup({
      account,
      scopes: [RESOURCE_SCOPE],
    });
    return res.accessToken;
  }
}

async function getBackendJwt() {
  if (backendJwt) return backendJwt;
  if (loginPromise) return await loginPromise;

  loginPromise = (async () => {
    let accessToken;
    try {
      accessToken = await getAccessTokenWithFallback();
    } catch (e) {
      throw new Error(e?.message || "Nie udało się zalogować (SSO/MSAL).");
    }

    const url = `${BACKEND_URL.replace(/\/+$/, "")}/v1/auth/msplugin/login`;

    let resp;
    try {
      resp = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ access_token: accessToken }),
      });
    } catch {
      throw new Error("Nie udało się połączyć z /msplugin/login.");
    }

    if (!resp.ok) {
      const text = await resp.text().catch(() => "");
      throw new Error(`Logowanie przez Microsoft nie powiodło się (${resp.status}). ${text}`);
    }

    const data = await resp.json().catch(() => ({}));
    backendJwt = data.token || null;

    if (!backendJwt) {
      throw new Error("Backend nie zwrócił tokenu aplikacji.");
    }

    if (backendJwt && !didPostLoginRefresh) {
      queueMicrotask(() => {
        refreshAllAfterLogin().catch(() => {});
      });
    }

    return backendJwt;
  })();

  try {
    return await loginPromise;
  } finally {
    loginPromise = null;
  }
}

async function refreshAllAfterLogin() {
  if (didPostLoginRefresh) return;
  didPostLoginRefresh = true;

  const hint = document.getElementById("ProjectHint");
  if (hint) hint.textContent = "Ładowanie danych…";

  const projectSelect = document.getElementById("ProjectSelect");
  const depSelect = document.getElementById("DepartmentSelect");
  const userSelect = document.getElementById("UserSelect");

  if (projectSelect) {
    projectSelect.disabled = true;
    projectSelect.innerHTML = `<option value="" disabled selected>Ładowanie…</option>`;
  }
  if (depSelect) {
    depSelect.disabled = true;
    depSelect.innerHTML = `<option value="" disabled selected>Ładowanie…</option>`;
  }
  if (userSelect) {
    userSelect.disabled = true;
    userSelect.innerHTML = `<option value="" disabled selected>Ładowanie…</option>`;
  }

  try {
    await Promise.all([
      initProjectsUI(),
      initDepartmentsUI(),
      fetchAssignableUsers(null),
    ]);
    if (hint) hint.textContent = "Dane załadowane. Wybierz projekt, dział i użytkownika.";
  } catch (e) {
    didPostLoginRefresh = false;
    if (hint) hint.textContent = e?.message || "Nie udało się załadować danych.";
  }
}

Office.onReady((info) => {
  if (info.host === Office.HostType.Outlook) {
    const sideload = document.getElementById("sideload-msg");
    const appBody = document.getElementById("app-body");
    if (sideload) sideload.style.display = "none";
    if (appBody) appBody.style.display = "flex";

    const runBtn = document.getElementById("run");
    if (runBtn) runBtn.onclick = run;

    initUsersUI().catch(() => {});

    const hint = document.getElementById("ProjectHint");
    if (hint) hint.textContent = "Trwa logowanie SSO…";

    getBackendJwt()
      .then(() => refreshAllAfterLogin())
      .catch((e) => {
        if (hint) hint.textContent = e?.message || "Nie udało się zalogować.";
      });
  }
});

function splitEmailHtml(html) {
  const s = (html || "").replace(/\r\n?/g, "\n");
  const candidates = [
    /<blockquote\b[^>]*>/i,
    /<hr\b[^>]*>/i,
    /\brole=["']separator["']/i,
    /<(div|span)[^>]+class=["'][^"']*(gmail_quote|gmail_extra|yj6qo|OutlookMessageHeader|MsoForwardText|MsoReplyText)["'][^>]*>/i,
    /<(div|span)[^>]+id=["'][^"']*(appendonsend|divRplyFwdMsg|originalmessage|replycontent|forwardedmessage)["'][^>]*>/i,
    /<(b|strong)[^>]*>\s*(From|Od)\s*:\s*<\/\1>/i,
    /<(b|strong)[^>]*>\s*(Sent|Wysłano)\s*:\s*<\/\1>/i,
    /<(b|strong)[^>]*>\s*(To|Do)\s*:\s*<\/\1>/i,
    /<(b|strong)[^>]*>\s*(Subject|Temat)\s*:\s*<\/\1>/i,
    /(?:^|>)[^<]{0,200}On [^<]+ wrote:/i,
    /(?:^|>)[^<]{0,200}(W dniu|Dnia)[^<]+napisał(?:a)?:/i,
  ];

  let cut;
  for (const re of candidates) {
    const m = re.exec(s);
    if (m && (cut === undefined || m.index < cut)) cut = m.index;
  }

  if (cut === undefined) {
    const flat = s
      .replace(/<style[\s\S]*?<\/style>/gi, "")
      .replace(/<script[\s\S]*?<\/script>/gi, "")
      .replace(/<head[\s\S]*?<\/head>/gi, "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/(p|div|li|tr|table)>/gi, "\n")
      .replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .replace(/\s+/g, " ");
    const m2 =
      /\b(From|Od)\s*:/i.exec(flat) ||
      /\b(Original Message|Forwarded message|Wiadomość oryginalna)\b/i.exec(flat);
    if (m2) {
      const key = m2[0];
      const tagAgnostic = new RegExp(
        key
          .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
          .split("")
          .map((ch) => (/\s/.test(ch) ? "\\s*" : `${ch}(?:<[^>]*>)*`))
          .join(""),
        "i"
      );
      const m3 = tagAgnostic.exec(s);
      if (m3) cut = m3.index;
    }
  }

  if (cut === undefined) return { bodyHtml: s, footerHtml: "" };
  return { bodyHtml: s.slice(0, cut), footerHtml: s.slice(cut) };
}

async function initProjectsUI() {
  const select = document.getElementById("ProjectSelect");
  const hint = document.getElementById("ProjectHint");

  if (!BACKEND_URL) {
    if (select) {
      select.innerHTML = `<option value="" disabled selected>Brak BACKEND_URL</option>`;
      select.disabled = true;
    }
    if (hint) hint.textContent = "Skonfiguruj BACKEND_URL w kodzie dodatku.";
    throw new Error("BACKEND_URL nie jest skonfigurowany.");
  }

  const jwt = await getBackendJwt();

  const endpoint = `${BACKEND_URL.replace(/\/+$/, "")}/v1/projects?limit=100&order_by=name&order_asc=true`;

  const controller = new AbortController();
  const to = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

  let resp;
  try {
    resp = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      credentials: "include",
      signal: controller.signal,
    });
  } finally {
    clearTimeout(to);
  }

  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`Projects fetch failed ${resp.status}: ${text}`);
  }

  const data = await resp.json().catch(() => ({}));
  const list = Array.isArray(data?.projects) ? data.projects : [];

  const normalized = list
    .map((p) => ({ uid: String(p?.project?.id ?? ""), name: p?.project?.name ?? "" }))
    .filter((p) => p.uid && p.name);

  if (!normalized.length) {
    if (select) {
      select.innerHTML = `<option value="" disabled selected>Brak przypisanych projektów</option>`;
      select.disabled = true;
    }
    if (hint) hint.textContent = "Nie masz przypisanych projektów lub brak uprawnień.";
    return;
  }

  if (select) {
    select.innerHTML = `<option value="" disabled selected>— wybierz projekt —</option>`;
    for (const p of normalized) {
      const opt = document.createElement("option");
      opt.value = p.uid;
      opt.textContent = p.name;
      opt.dataset.projectName = p.name;
      select.appendChild(opt);
    }
    select.disabled = false;

    const pre = qp("project_uid_preselect");
    if (pre) {
      const found = Array.from(select.options).find((o) => o.value === pre);
      if (found) select.value = pre;
    }

    select.addEventListener("change", () => {
      const opt = select.selectedOptions[0];
      if (hint) hint.textContent = opt ? `Wybrano: ${opt.textContent}` : "";
    });
  }
}

async function initDepartmentsUI() {
  const depSelect = document.getElementById("DepartmentSelect");
  if (!depSelect) return;

  if (!BACKEND_URL) {
    depSelect.innerHTML = `<option value="" disabled selected>Brak BACKEND_URL</option>`;
    depSelect.disabled = true;
    throw new Error("BACKEND_URL nie jest skonfigurowany.");
  }

  const jwt = await getBackendJwt();
  const endpoint = `${BACKEND_URL.replace(/\/+$/, "")}/v1/departments?limit=200&order_by=name&order_asc=true`;

  const controller = new AbortController();
  const to = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

  try {
    const resp = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      credentials: "include",
      signal: controller.signal,
    });

    if (!resp.ok) {
      const text = await resp.text().catch(() => "");
      throw new Error(`Departments fetch failed ${resp.status}: ${text}`);
    }

    const data = await resp.json().catch(() => ({}));
    const raw =
      (Array.isArray(data?.departments) && data.departments) ||
      (Array.isArray(data?.items) && data.items) ||
      [];

    const normalized = raw
      .map((d) => {
        const obj = d?.department ?? d;
        return {
          uid: String(obj?.id ?? obj?.uid ?? ""),
          name: String(obj?.name ?? ""),
        };
      })
      .filter((d) => d.uid && d.name);

    if (!normalized.length) {
      depSelect.innerHTML = `<option value="" disabled selected>Brak dostępnych działów</option>`;
      depSelect.disabled = true;
      return;
    }

    depSelect.innerHTML = `<option value="" disabled selected>— wybierz dział —</option>`;
    for (const d of normalized) {
      const opt = document.createElement("option");
      opt.value = d.uid;
      opt.textContent = d.name;
      depSelect.appendChild(opt);
    }

    depSelect.disabled = false;

    const pre = qp("department_uid_preselect");
    if (pre) {
      const found = Array.from(depSelect.options).find((o) => o.value === pre);
      if (found) depSelect.value = pre;
    }
  } finally {
    clearTimeout(to);
  }
}

async function initUsersUI() {
  const userSearch = document.getElementById("UserSearch");
  const userSelect = document.getElementById("UserSelect");
  const userHint = document.getElementById("UserHint");

  if (!userSearch || !userSelect) return;

  userSelect.innerHTML = `<option value="" disabled selected>Ładowanie użytkowników…</option>`;
  userSelect.disabled = true;
  if (userHint) userHint.textContent = "Ładowanie listy użytkowników…";

  userSearch.addEventListener("input", () => {
    const q = (userSearch.value || "").trim();
    if (usersDebounceTimer) clearTimeout(usersDebounceTimer);
    usersDebounceTimer = setTimeout(() => {
      fetchAssignableUsers(q ? q : null).catch((e) => {
        userSelect.innerHTML = `<option value="" disabled selected>Nie udało się załadować użytkowników</option>`;
        userSelect.disabled = true;
        if (userHint) userHint.textContent = e?.message || "Błąd pobierania użytkowników.";
      });
    }, 300);
  });

  userSelect.addEventListener("change", () => {
    const opt = userSelect.selectedOptions?.[0];
    if (userHint) userHint.textContent = opt ? `Wybrano: ${opt.textContent}` : "";
  });
}

async function fetchAssignableUsers(search) {
  const userSelect = document.getElementById("UserSelect");
  const userHint = document.getElementById("UserHint");

  const qRaw = search === null || search === undefined ? null : String(search).trim();
  const q = qRaw && qRaw.length ? qRaw : null;

  const key = q ? `q:${q}` : "all";
  if (key === lastUsersQuery) return;
  lastUsersQuery = key;

  const jwt = await getBackendJwt();

  if (usersController) {
    try {
      usersController.abort();
    } catch {}
  }
  usersController = new AbortController();
  const to = setTimeout(() => usersController.abort(), FETCH_TIMEOUT_MS);

  const endpointBase = `${BACKEND_URL.replace(/\/+$/, "")}/v1/users/outlook-assignable`;
  const endpoint = q ? `${endpointBase}?search=${encodeURIComponent(q)}` : endpointBase;

  try {
    if (userSelect) {
      userSelect.innerHTML = q
        ? `<option value="" disabled selected>Szukanie: ${escapeHtml(q)}…</option>`
        : `<option value="" disabled selected>Ładowanie użytkowników…</option>`;
      userSelect.disabled = true;
    }

    const resp = await fetch(endpoint, {
      method: "GET",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt}`,
      },
      credentials: "include",
      signal: usersController.signal,
    });

    if (!resp.ok) {
      const text = await resp.text().catch(() => "");
      throw new Error(`Users fetch failed ${resp.status}: ${text}`);
    }

    const data = await resp.json().catch(() => ({}));
    const list = Array.isArray(data?.users) ? data.users : [];

    const normalized = list
      .map((u) => ({
        id: String(u?.id ?? ""),
        name: String(u?.name ?? ""),
      }))
      .filter((u) => u.id && u.name);

    if (!normalized.length) {
      if (userSelect) {
        userSelect.innerHTML = `<option value="" disabled selected>Brak użytkowników</option>`;
        userSelect.disabled = true;
      }
      if (userHint) userHint.textContent = q ? "Brak wyników." : "Brak użytkowników.";
      return;
    }

    if (userSelect) {
      userSelect.innerHTML = `<option value="" disabled selected>— wybierz użytkownika —</option>`;
      for (const u of normalized) {
        const opt = document.createElement("option");
        opt.value = u.id;
        opt.textContent = u.name;
        userSelect.appendChild(opt);
      }
      userSelect.disabled = false;
    }

    if (userHint) userHint.textContent = q ? "Wybierz użytkownika z listy wyników." : "Użytkownicy załadowani.";

    const pre = qp("user_id_preselect");
    if (pre && userSelect) {
      const found = Array.from(userSelect.options).find((o) => o.value === pre);
      if (found) userSelect.value = pre;
    }
  } finally {
    clearTimeout(to);
  }
}

async function getMailAttachments(mail) {
  const attachments = [];

  // MessageCompose
  if (typeof mail.getAttachmentsAsync === "function") {
    const attList = await new Promise((resolve, reject) => {
      mail.getAttachmentsAsync((res) => {
        if (res.status === Office.AsyncResultStatus.Succeeded) {
          resolve(res.value || []);
        } else {
          reject(res.error || new Error("getAttachmentsAsync failed"));
        }
      });
    });

    for (const att of attList) {
      try {
        const value = await new Promise((resolve, reject) => {
          mail.getAttachmentContentAsync(att.id, (res) => {
            if (res.status === Office.AsyncResultStatus.Succeeded) {
              resolve(res.value);
            } else {
              reject(
                res.error ||
                new Error("getAttachmentContentAsync failed")
              );
            }
          });
        });

        if (
          value.format !==
          Office.MailboxEnums.AttachmentContentFormat.Base64
        ) {
          continue;
        }

        const MAX_BYTES = 12 * 1024 * 1024;

        if (
          typeof att.size === "number" &&
          att.size > MAX_BYTES
        ) {
          continue;
        }

        attachments.push({
          file_name: att.name,
          content_type:
            value.contentType || "application/octet-stream",
          content_base64: value.content,
        });
      } catch (e) {
        console.warn(
          "Nie udało się pobrać załącznika:",
          att?.name,
          e
        );
      }
    }

    return attachments;
  }

  // MessageRead - obecny mechanizm
  const attList = mail.attachments || [];

  for (const att of attList) {
    try {
      const value = await new Promise((resolve, reject) => {
        mail.getAttachmentContentAsync(att.id, (res) => {
          if (res.status === Office.AsyncResultStatus.Succeeded) {
            resolve(res.value);
          } else {
            reject(
              res.error ||
              new Error("getAttachmentContentAsync failed")
            );
          }
        });
      });

      if (
        value.format !==
        Office.MailboxEnums.AttachmentContentFormat.Base64
      ) {
        continue;
      }

      const MAX_BYTES = 12 * 1024 * 1024;

      if (
        typeof att.size === "number" &&
        att.size > MAX_BYTES
      ) {
        continue;
      }

      attachments.push({
        file_name: att.name,
        content_type:
          value.contentType || "application/octet-stream",
        content_base64: value.content,
      });
    } catch (e) {
      console.warn(
        "Nie udało się pobrać załącznika:",
        att?.name,
        e
      );
    }
  }

  return attachments;
}

function setRunButtonLoading(isLoading) {
  const btn = document.getElementById("run");
  if (!btn) return;

  if (isLoading) {
    btn.disabled = true;
    btn.classList.add("loading");
    btn.innerHTML = `
      <span class="spinner" aria-hidden="true"></span>
      Zapisywanie…
    `;
  } else {
    btn.disabled = false;
    btn.classList.remove("loading");
    btn.textContent = "Zapisz";
  }
}

export async function run() {
  const taskInput = document.getElementById("taskContent");
  const taskNameInput = document.getElementById("taskName");
  const statusEl = document.getElementById("attachment-status");

  const includeAttachments = !!document.getElementById("include-attachments")?.checked;
  const excludeMailContent = !!document.getElementById("exclude-mail-content")?.checked;

  const projectSelect = document.getElementById("ProjectSelect");
  const depSelect = document.getElementById("DepartmentSelect");
  const userSelect = document.getElementById("UserSelect");

  if (statusEl) statusEl.textContent = "";

  if (!BACKEND_URL) {
    if (statusEl) statusEl.textContent = "Błąd konfiguracji: brak BACKEND_URL.";
    return;
  }

  const projectOpt = projectSelect?.selectedOptions?.[0];
  const projectUid = (projectOpt?.value ?? "").trim() || null;
  const projectName = projectOpt?.dataset?.projectName || null;

  if (!projectUid) {
    if (statusEl) statusEl.textContent = "Wybierz projekt przed zapisaniem zadania.";
    projectSelect?.focus();
    return;
  }

  const depOpt = depSelect?.selectedOptions?.[0];
  const departmentUid = (depOpt?.value ?? "").trim() || null;

  if (!departmentUid) {
    if (statusEl) statusEl.textContent = "Wybierz dział przed zapisaniem zadania.";
    depSelect?.focus();
    return;
  }

  const userOpt = userSelect?.selectedOptions?.[0];
  const selectedUserId = (userOpt?.value ?? "").trim() || null;

  if (!selectedUserId) {
    if (statusEl) statusEl.textContent = "Wybierz użytkownika przed zapisaniem zadania.";
    userSelect?.focus();
    return;
  }

  let jwt;
  try {
    jwt = await getBackendJwt();
    decodeJwt(jwt);
  } catch (e) {
    if (statusEl) statusEl.textContent = e?.message || "Nie udało się zalogować przez Microsoft.";
    return;
  }
  setRunButtonLoading(true);

  const mail = Office.context.mailbox.item;
  const conversationId = normalizeString(mail?.conversationId || "");

  mail.body.getAsync("html", async function (result) {
    if (result.status !== Office.AsyncResultStatus.Succeeded) {
      if (statusEl) statusEl.textContent = "Błąd pobierania treści maila.";
      return;
    }

    const mailContent = result.value || "";
    const subject = normalizeString(await getSubjectAsync(mail));
    const { bodyHtml, footerHtml } = splitEmailHtml(mailContent);

    let attachments = [];

    if (includeAttachments) {
      try {
        attachments = await getMailAttachments(mail);
      } catch (e) {
        console.error("Błąd pobierania załączników:", e);

        if (statusEl) {
          statusEl.textContent =
            "Nie udało się pobrać załączników wiadomości.";
        }

        return;
      }
    }

    const requestData = {
      project_uid: projectUid,
      user_id: selectedUserId,
      task_name: normalizeString(taskNameInput?.value || ""),
      task_content: normalizeString(taskInput?.value || ""),
      department_uid: departmentUid,
      mail_subject: normalizeString(subject),
      mail_content: normalizeString(bodyHtml),
      mail_footer: normalizeString(footerHtml),
      conversation_id: conversationId,
      exclude_mail_content: !!excludeMailContent,
      attachments,
    };

    try {
      const resp = await fetch(`${BACKEND_URL.replace(/\/+$/, "")}/v1/external_task/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt}`,
        },
        credentials: "include",
        body: JSON.stringify(requestData),
      });

      if (resp.ok) {
        await resp.json().catch(() => ({}));

        if (statusEl) {
          statusEl.textContent = includeAttachments
            ? attachments.length
              ? `Zadanie zapisane (projekt: ${projectName || projectUid}). Załączniki: ${attachments.map((a) => a.file_name).join(", ")}`
              : `Zadanie zapisane (projekt: ${projectName || projectUid}, brak załączników).`
            : `Zadanie zapisane (projekt: ${projectName || projectUid}, bez załączników).`;
        }

        if (taskInput) taskInput.value = "";
        if (taskNameInput) taskNameInput.value = "";

        Office.context.ui.closeContainer();
      } else {
        const text = await resp.text().catch(() => "");
        setRunButtonLoading(false);
        if (statusEl) statusEl.textContent = `Błąd zapisu zadania: ${resp.status} ${text}`;
      }
    } catch {
      setRunButtonLoading(false);
      if (statusEl) statusEl.textContent = "Błąd połączenia z backendem.";
    }
  });
}
